export enum SectionEnum {
  FORRENT = 'for-rent',
  FORSALE = 'for-sale',
}
